import React from "react"
export const BikeIcon = ({ size}) => {
	return (
		<svg 
			width={ size}
			height={ size}
			viewBox="0 0 22 22" 
			fill="none" 
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="bike">
				<path 
					id="icon" 
					d="M11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19H11ZM12 15H13C13 14.7348 12.8946 14.4804 12.7071 14.2929L12 15ZM8.5 11.5L7.79289 10.7929C7.40237 11.1834 7.40237 11.8166 7.79289 12.2071L8.5 11.5ZM12.5 7.5L13.2071 6.79289C12.8166 6.40237 12.1834 6.40237 11.7929 6.79289L12.5 7.5ZM16 11L15.2929 11.7071C15.4804 11.8946 15.7348 12 16 12V11ZM19 12C19.5523 12 20 11.5523 20 11C20 10.4477 19.5523 10 19 10V12ZM8 18C8 19.1046 7.10457 20 6 20V22C8.20914 22 10 20.2091 10 18H8ZM6 20C4.89543 20 4 19.1046 4 18H2C2 20.2091 3.79086 22 6 22V20ZM4 18C4 16.8954 4.89543 16 6 16V14C3.79086 14 2 15.7909 2 18H4ZM6 16C7.10457 16 8 16.8954 8 18H10C10 15.7909 8.20914 14 6 14V16ZM20 18C20 19.1046 19.1046 20 18 20V22C20.2091 22 22 20.2091 22 18H20ZM18 20C16.8954 20 16 19.1046 16 18H14C14 20.2091 15.7909 22 18 22V20ZM16 18C16 16.8954 16.8954 16 18 16V14C15.7909 14 14 15.7909 14 18H16ZM18 16C19.1046 16 20 16.8954 20 18H22C22 15.7909 20.2091 14 18 14V16ZM13 19V15H11V19H13ZM12.7071 14.2929L9.20711 10.7929L7.79289 12.2071L11.2929 15.7071L12.7071 14.2929ZM9.20711 12.2071L13.2071 8.20711L11.7929 6.79289L7.79289 10.7929L9.20711 12.2071ZM11.7929 8.20711L15.2929 11.7071L16.7071 10.2929L13.2071 6.79289L11.7929 8.20711ZM16 12H19V10H16V12ZM16 5V7C17.1046 7 18 6.10457 18 5H16ZM16 5H14C14 6.10457 14.8954 7 16 7V5ZM16 5V3C14.8954 3 14 3.89543 14 5H16ZM16 5H18C18 3.89543 17.1046 3 16 3V5Z" 
					fill="currentColor"
				/>
			</g>
		</svg>

	)
}
